var searchResult = {
    initTabs: function(){
        var touchTabs = new TouchTabs('.swip-tap', {
            seledClass: 'swiper-li',
            hookfunction: function(t){
                var value=$('#search-inp').text();
                if(value){
                    value=encodeURIComponent(value);
                    if (getUrlPara('ishot')) {
                        t =  t + '&ishot=' + getUrlPara('ishot');
                    }
                    location.href='/list?kw='+value+'&type='+t;
                }

            },
        });
    },

    pageIndex: 2,
    isLoading: false,
    template: '#search-result-flow',
    contentBox:'.content-list-box',
    //获取数据
    getData: function (pageIndex) {
        msLoader.setLoad();
        var _this = this;
        var url = window.location.href;
        var option = {
            pn: pageIndex,
            return: 'json',
        };
        _this.isLoading = true;
        getJson(url, option, function (data) {
            if(window.cateData.pageSubModule === 'search-author'){
                if (data.authorList.count === 0) {
                    //设置加载完成
                    msLoader.setEnd();
                } else {
                    _this.handleDate(data.authorList.content);
                    _this.pageIndex += 1;
                    _this.isLoading = false;
                }
            }else {
                if (data.alllist.count === 0) {
                    //设置加载完成
                    msLoader.setEnd();
                } else {
                    _this.handleDate(data.alllist.content);
                    _this.pageIndex += 1;
                    _this.isLoading = false;
                }
            }
        });
    },

    //处理数据插入容器
    handleDate: function (data) {
        var _this = this;
        var contentEl = '';
        contentEl = document.querySelector(_this.contentBox);//获取容器
        /*if(window.cateData.pageModule === 'searchResult' && window.cateData.pageSubModule === 'result') {
            contentEl = document.querySelector('.content-list-box');//获取容器
        }else{
            contentEl = document.querySelector('.author-list-box');//获取容器
        }*/

        //获取模板
        var itemsHTML = data.map(_this.getItemHTML, _this).join('');

        var proxyElem = document.createElement('div'); //创建代理容器
        proxyElem.innerHTML = itemsHTML;

        var items = proxyElem.querySelectorAll('.list-item'); //获取处理过的html代码

        //添加进容器
        items.forEach(function (item) {
            contentEl.appendChild(item);
        });
        stopRurnLik();
        gettatInfo();
        setLiveIcon();
    },

    //获取模板
    getItemHTML: function (data) {
        //判断subModule 获取不同的模板
        var itemTemplateSrc = document.querySelector(this.template).innerHTML;
        //处理数据
        if (data.status) {//会议状态
            switch (data.status) {
                case 1:
                    data.showMetLabel = 'met-label-regd';
                    break;
                case 2:
                    data.showMetLabel = 'met-label-processing';
                    break;
                case 3:
                    data.showMetLabel = 'met-label-over';
                    break;
            }
        }

        //判断直播链接是否存在
        if(data.liveUrl){
            data.showLiveText = 'hide';
            data.showLiveBt = '';
            data.showMetPlay = 'met-playicon';
        }else{
            data.showLiveText = '';
            data.showLiveBt = 'hide';
            data.showMetPlay = '';
        }
        if(data.canDoDesc){ //会议按钮状态文字
            data.liveName = data.canDoDesc;
        }
        if(data.avatar){
            data.avatar =  data.avatar;
        }else {
            data.avatar = '/static/mobile/images/avatar.png';
        }

        data.detailUrl = data.url

        data.fullWidth = '';
        data.showPlay = ''; // 显示播放按钮
        data.showLike = ''; // 显示收藏和评论
        data.showCart = 'hide'; // 显示购物车
        data.showAuthor = ''; // 显示作者
        data.showPriceBox = 'hide'; // 显示参考价格
        data.showFileSize = 'hide'; // 显示文件大小
        data.showVideoAct = 'hide'; // 显示视频弹窗
        data.showFiledown = 'hide'; // 显示文件下载
        data.showActivity = 'hide'; // 显示市场活动状态

        data.showPrice = 'hide'; // 显示价格
        data.showSale = 'hide'; // 显示促销价
        data.showPriceDel = 'hide'; // 显示带删除线的价格
        data.showActivityVideo = 'hide'; // 直播结束显示视频播放按钮
        data.collectStatus = data.collect == '1';  //点赞状态
        data.showVip = data.author_vip ? '' : 'hide'; // 作者VIP
        data.showAll = data.type_en == 'all' || data.type_en == 'product' ? '' : 'hide'; // 是否显示全部
        data.activityStatus = data.status == '1' ? 'met-label-regd' : (data.status=='2' ? 'met-label-processing' : 'met-label-over');
        data.showProdNewTag = data.slogan == 'new'? 'product-pic-new-tag' : '';
        data.isProduct = data.type == 'product'? 'item-img-box-prod':'';
        data.isEshop = data.type == 'eshop'? 'auth-eshop':'';
        data.objectFit = data.type == 'eshop' || data.type == 'product'? 'objectFit':'';

        switch (data.type) {
            case 'product':
                data.showPriceBox = '';
                data.showAuthor = 'hide';
                data.showLike = 'hide';
                data.fullWidth = 'full';
                data.typeUrl = window.solution_host + '/products/server.html';
                if(data.sale) {
                    data.showSale = '';
                    if(data.price && data.price !== '咨询客服获取特惠价') {
                        data.showPriceDel = ''
                    }
                    data.showContact = 'hide'; // 是否显示联系戴尔
                }else if (data.price && data.price !== '咨询客服获取特惠价') {
                    data.showPrice = ''; // 是否显示参考价格
                    data.showContact = 'hide'; // 是否显示联系戴尔
                } else {
                    data.showPrice = 'hide';
                    data.showContact = '';
                }
                break;
            case 'eshop':
                data.showPriceBox = '';
                data.showAuthor = 'hide';
                data.showLike = 'hide';
                data.showCart = '';
                data.fullWidth = '';
                if(data.sale) {
                    data.showSale = '';
                    if(data.price && data.price !== '咨询客服获取特惠价') {
                        data.showPriceDel = ''
                    }
                    data.showContact = 'hide'; // 是否显示联系戴尔
                }else if (data.price && data.price !== '咨询客服获取特惠价') {
                    data.showPrice = ''; // 是否显示参考价格
                    data.showContact = 'hide'; // 是否显示联系戴尔
                } else {
                    data.showPrice = 'hide';
                    data.showContact = '';
                }
                break;
            case 'filelist':
                if (data.fileType !== 'video') {
                    data.showAuthor = 'hide';
                    data.showFileSize = '';
                } else {
                    data.showPlay = 'play';
                    data.showVideoAct = '';
                }
                if (data.fileType === 'file') {
                    data.showFiledown = '';
                }
                break;
            case 'activity':
                data.showLike = 'hide';
                data.fullWidth = 'full';
                data.showActivity = '';
                if (data.status != 1) {
                    data.showPlay = 'play';
                    data.showActivityVideo = '';
                }
                break;

        }

        //设置作者链接
        if(data.author_id){
            data.authorUrl = window.rootUrl + '/author/' + data.author_id;
        }

        //没有图片，替换默认图片
        if (!data.coverurl) {
            if(data.status === '2'){
                data.coverurl = '/static/mobile/images/defaultimg-zbz.jpg';
            }else{
                data.coverurl = '/static/mobile/images/defaultimg.jpg';
            }
        }

        //渲染模板
        return itemTemplateSrc.replace(/\{\{([\w\-_\.]+)\}\}/gi, function (match, key) {
            var value = data;
            key.split('.').forEach(function (part) {
                value = value[part];
            });
            return value;
        });
    },

    //判断是否已到页面底部
    isBottom: function () {
        var _this = this;
        var scrollT = Math.max(document.body.scrollTop, document.documentElement.scrollTop); //滚动条的垂直偏移
        var scrollH = document.documentElement.scrollHeight || document.body.scrollHeight; //元素的整体高度
        var clientH = document.documentElement.clientHeight || document.body.clientHeight; //元素的可见高度
        if (scrollT >= scrollH - clientH - 100) { //100为修正值
            if (!_this.isLoading) {
                _this.getData(_this.pageIndex);
            }
        }
    },

    //添加滚动监听事件
    addScrollEvent: function () {
        var _this = this;
        window.onscroll = function () {
            _this.isBottom();
        };
    },

    //取消收藏
    cancelCollection: function (id, title) {
        var _this = this;
        msg.dialog('确认要取消收藏吗？', function () {
            var usrInfo = isLogin();
            postJson(window.cateData.api.like, {articleId: id, status: 0, sess: usrInfo.session}, function (data) {
                if (data.result > 0) {
                    userRecode({behaviorType: '取消收藏', behaviorResult: '无'});
                    loginOut();
                    return;
                } else {
                    //行为记录
                    userRecode({behaviorType: '取消收藏', behaviorResult: title});
                }
            }, true);

            // 删除页面元素
            _this.delMyCollect(id);

            //检查页面item数 小于8个则加载数据
            var itemArr = document.querySelectorAll('.list-item');
            if (itemArr.length < 8) {
                searchResult.isBottom();
            }
        });
    },

    //删除评论
    delCommnet: function (id, uid, content) {
        console.log('删除评论');
        msg.dialog('确认要取消收藏吗？', function () {
            var url = window.cateData.api.delCommnet + '/' + id + '/' + uid;
            getJson(url, '', function (data) {
                console.log(data);
                userRecode({behaviorType: '删除评论', behaviorResult: content});
            });
        });
    },

    gotoEshop: function () {
        var name = getUrlPara('type');
        var word = getUrlPara('kw');
        if (name === 'shop' && word.length > 0) {
            location.href = window.eshop_host + '/index.php?route=product/search&search=' + encodeURI(word);
            return;
        }
    },

    init: function () {

        this.gotoEshop();

        //判断tab是否存在
        var isTapEx = document.querySelector('.swip-tap');

        if(window.cateData.pageModule === 'search' && isTapEx) {
            this.initTabs();
        }

        if(isTapEx){
            var curActiveTab = null;
            var oTypeCn = document.querySelector('#typeCn');
            var oTabList = document.querySelectorAll('#result-swiper li');
            for (var i = 0; i < oTabList.length; i++) {
                if (oTabList[i].innerText == oTypeCn.innerText) {
                    curActiveTab = oTabList[i];
                }
            }
            var curWidth = document.body.clientWidth || document.documentElement.clientWidth;
            var curLeftDis = curActiveTab.offsetLeft + curActiveTab.offsetWidth;
            if (curLeftDis > curWidth) {
                var oSwiper = document.querySelector('#result-swiper .swiper-wrapper');
                var slideW = Math.ceil(curLeftDis) - Math.ceil(curWidth);
                oSwiper.style.transform = 'translate3d(-' + slideW + 'px, 0px, 0px)';
            }


            var swiper1 = new Swiper('#result-swiper', {
                freeMode: true,
                freeModeMomentumRatio: 0.5,
                slidesPerView: 'auto'
            });
        }
        //判断是否登录
        // if (!isLogin() && window.cateData.pageModule === 'searchResult') {
        //     window.location.href = window.cateData.url.loginAndBack;
        // }

        if (window.cateData.isHaveData.common) { //判断页面是否有数据
            msLoader.setShow();

            //先执行一次
            this.isBottom();

            //添加监听
            this.addScrollEvent();
        }
    },
    gotoAuthor:function () {
        if(window.location.href.indexOf('?')>-1){
            location.href=window.location.href+'&auth=on'
        }else {
            location.href=window.location.href+'?auth=on'
        }
    },
    gotoArticle:function (word,type) {

        // 商城切换逻辑
        if(type === 'shop'){
            type = 'all';
        }
        if(type === 'shopRe'){
            type = 'shop'
        }
        if (getUrlPara('ishot')) {
            type += "&ishot=" + getUrlPara('ishot')
        }
        location.href='/list/'+word+'?type='+type ;
    }
    };


if (window.cateData.pageModule === 'searchResult') {
    switch (window.cateData.pageSubModule) {
        case 'result':
            searchResult.template = '#search-result-flow';
            searchResult.contentBox = '.content-list-box';
            break;
        case 'search-author':
            searchResult.template = '#search-author-flow';
            searchResult.contentBox = '.author-list-box';
            break;
        case 'search-shop':
            searchResult.template = '#search-shop-flow';
            searchResult.contentBox = '.shop-list-box';
            break;

    }
}
